import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSelectInsuranceProfile from './useSelectInsuranceProfile';
import {
  insuranceDetailsError,
  insuranceDetailsReceived,
  insuranceDetailsSubmitting,
} from '../../../ducks/insurance/details';
import { getInsuranceDetailsUrl } from '../../../core/dapi/insuranceProfile';
import { POKITDOK_CODE_URGENT_CARE } from '../../../constants/index';
import { getAccountSummaryById } from '../../../core/dapi/account';
import { apiGetDispatchable } from '../../../core/dapi';
import { accountSummaryError, receiveAccountSummary } from '../../../actions/account';
import { isEmptyObject } from '../../../core/util/object';
import { DataLock } from '../../../core/util/dataLock';
import useSelectRefreshInsurance from '../components/Insurance/components/InsuranceCard/hooks/useSelectRefreshInsurance';
import { emptyFunction } from '../../../core/util/function';

const shouldFetchInsuranceDetails = ({
  eligibilityRequestId,
  insuranceProfileId,
  insuranceDetails,
}: any) => {
  return isEmptyObject(insuranceDetails) && eligibilityRequestId && insuranceProfileId;
};

const dataLock = new DataLock('');
const eligibilityRequestLock = new DataLock('');

export default (userProfileId: any) => {
  const dispatch = useDispatch();
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);
  const insuranceDetails = useSelector(
    (state: any) => state.insuranceDetails.result && state.insuranceDetails.result[userProfileId]
  );

  const refreshInsurance = useSelectRefreshInsurance(userProfileId, emptyFunction);

  const {
    most_recent_eligibility_request_id: mostRecentRequestId,
    eligibility_request_id: regRequestId,
    insurance_profile_id: insuranceProfileId,
    account_id: accountId,
  } = insuranceProfile || {};

  const eligibilityRequestId = mostRecentRequestId || regRequestId;

  useEffect(() => {
    if (!eligibilityRequestId && !eligibilityRequestLock.isSame(userProfileId)) {
      eligibilityRequestLock.updateValue(userProfileId);
      refreshInsurance({ stopPropagation() {} });
      return;
    }

    if (dataLock.isSameOrSet(userProfileId)) return;

    if (
      shouldFetchInsuranceDetails({
        eligibilityRequestId,
        insuranceProfileId,
        insuranceDetails,
      })
    ) {
      dispatch(insuranceDetailsSubmitting(true));

      const detailsUrl = getInsuranceDetailsUrl(eligibilityRequestId, insuranceProfileId, [
        POKITDOK_CODE_URGENT_CARE,
      ]);

      const onSuccess = (response: any) => {
        const url = getAccountSummaryById(accountId);
        dispatch(apiGetDispatchable(url, receiveAccountSummary, accountSummaryError));

        dataLock.updateValue('');
        return insuranceDetailsReceived(response, userProfileId);
      };

      const onError = (response: any) => {
        return insuranceDetailsError(response);
      };

      dispatch(apiGetDispatchable(detailsUrl, onSuccess, onError));
    }
  }, [
    dispatch,
    accountId,
    userProfileId,
    insuranceDetails,
    insuranceProfileId,
    eligibilityRequestId,
    refreshInsurance,
  ]);

  return insuranceDetails;
};
